import React, { PropsWithChildren } from 'react';
import css from './custom-page.module.scss';
import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';
import Description from 'src/components/description-block/description';
import { Link } from 'react-router-dom';
import { PageEntityType } from 'src/types/custom-page/custom-page';

export interface PageBlockProps<T> {
  items: T[];
  title: string;
  description: string;
  type: PageEntityType;
  path?: string;
  pages?: { path: string; title: string }[];
}

export default function CustomPageBlock<T>({
  title,
  description,
  type,
  path,
  children
}: Readonly<PropsWithChildren<Omit<PageBlockProps<T>, 'items'>>>) {
  return (
    <div className={css.serviceContainer}>
      <div className={css.body}>
        <Link to={path ?? ''} className={css.link}>
          <p>Всі {getEntityName(type).toLocaleLowerCase()} </p> <EventLinkIcon />
        </Link>
        <div className={css.title}>{title}</div>
        <Description className={css.description} description={description ?? ''} />
        {children}
      </div>
    </div>
  );
}

export const getEntityName = (type: PageEntityType) => {
  switch (type) {
    case PageEntityType.Partners:
      return 'Партнери';
    case PageEntityType.Event:
      return 'Події';
    case PageEntityType.Service:
      return 'Послуги';
    case PageEntityType.ContactCard:
      return 'Контакти';
    case PageEntityType.Vacancy:
      return 'Вакансії';
    case PageEntityType.Banner:
      return 'Банер';
      case PageEntityType.TextBlock:
      return 'Текстовий розділ';
    default:
      return '';
  }
};
